import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useNavigate, useParams } from "react-router-dom";

import Schemas from "schemas";
import ImageGallery from "react-image-gallery";
import { Control } from "components/ui-kit/control";
import { Button, Container, Frame, PhotoDropzone, RowWrapper } from "components/ui-kit/styled-templates";

import ArticlesAPI from "api/articles-api";

import useBodyBackground from "hooks/useBodyBackground";
import useFormControl from "hooks/useFormControl";
import { useStorageListener } from "hooks/useStorage";

import { EForms, ERoles } from "types/enums";
import Sidebar from "arui-feather/sidebar";
import styled from "styled-components";
import _ from "lodash";
import Tags from "../tools/tags";
import shareImage from "../../assets/images/share.png";
import copy from "copy-to-clipboard";
import toast from "react-hot-toast";
import Gallery from "../tools/gallery";

const NewsListPage = (props: { mode: "create" | "edit" }) => {
    const { t } = useTranslation();

    const { mode } = props;

    useBodyBackground("white");
    const { newsId: articleId } = useParams();
    const navigate = useNavigate();

    const [previewVisible, setPreviewVisible] = useState(false);

    const article = useStorageListener(`news.${articleId}`, {});

    const { onSubmit, setValues, data } = useFormControl({ name: EForms.newsArticle, schema: Schemas[EForms.newsArticle] });

    const handler = {
        submit: async (d: any) => {
            if (mode === "create") {
                const { id: articleId } = await ArticlesAPI.createArticle({ ...d });
                navigate(`/news/${articleId}`);
            } else {
                // check customDate format - DD.MM.YYYY HH:mm
                let customDate = d.customDate;
                // check with regex
                let datePattern = /^(\d{2}).(\d{2}).(\d{4}) (\d{2}):(\d{2})$/;
                if (!datePattern.test(customDate)) {
                    toast.error('Неверный формат даты и времени. Правильный формат: ДД.ММ.ГГГГ ЧЧ:мм');
                    return;
                }

                await ArticlesAPI.updateArticle({ id: articleId, ...d });
                navigate(`/news/${articleId}`);
            }
        }
    };

    // @ts-ignore
    useEffect(ArticlesAPI.getAllArticles, []);

    useEffect(() => {
        setValues(article);
    }, [article]);

    return (
        <Container extra="form { width: 100%; margin: 30px 0; }">
            <form name={EForms.newsArticle} onSubmit={onSubmit(handler.submit)}>
                <Control.Input name="title" label={t("5fwbdk6grkp")} placeholder={t("5fmprlv4a77")} isRequired />
                <Control.File
                    name="cover"
                    label={t("o807yxyo6eo")}
                    multiple
                    dropzoneProps={{ label: `Загрузить фото (не более 1 МБ, формат JPG, Ширина 1200 пикселей, Высота 800 пикселей)`}}
                    maxFilesNumber={1}
                    onChange={(e) => ({ target: { value: e.target.value[0] } })}
                    isRequired
                >
                    <PhotoDropzone />
                </Control.File>

                <Control.File name="photos" label={t("9bvpek1gpn")}
                              accept="image/png, image/jpeg, image/jpg, webp, image/gif"
                              dropzoneProps={{ label: `Загрузить фото (не более 1 МБ, формат JPG, Ширина 1200 пикселей, Высота 800 пикселей)`}}
                              multiple isRequired />

                <Control.HTML name="content" label={t("r8tud442af8")} placeholder={t("kpai0gui95")} isRequired />
                <Control.Tags name="tags" label={t("bf07dqhg7c8")} placeholder={t("q3cjkh73syc")} />
                <Control.Input name="customDate" label={"Дата и время"} placeholder={"Дата и время (в формате ДД.ММ.ГГГГ ЧЧ:мм)"} isRequired />
                <Button type="submit">{t("d8vnerykxxv")}</Button>
            </form>

            <div style={{ marginTop: 10, marginBottom: 10 }}>
                <span style={{ cursor: "pointer", textDecoration: "underline" }} onClick={() => {
                    setPreviewVisible(true);
                }}>
                    предпросмотр
                </span>
            </div>

            <Sidebar  width={Math.min(window.innerWidth, 1020)} visible={previewVisible} onCloserClick={() => setPreviewVisible(false)}>
                {previewVisible == false ? null :
                    <>
                        <Article.Wrapper>
                            {/*{_.get(data, "cover") && <Article.Cover src={_.get(data, "cover")} />}*/}

                            <h2>{_.get(data, "title", "...")}</h2>

                            {data?.photos?.length > 0 && (
                                <>
                                    <div style={{background: 'white', height: '460px', maxHeight: '460px', width: '100%'}}  >
                                        <ImageGallery
                                            showPlayButton={false}
                                            items={data?.photos.map(x => ({original: x, thumbnail: x, originalHeight: 360, thumbnailHeight: 60}))} />
                                    </div>
                                    {/*<Gallery photos={data?.photos} extra="margin-top: 15px;" />*/}
                                </>
                            )}

                            <Tags tags={_.get(data, "tags", [])} />
                            <Article.Content className={'news_article'}
                                             dangerouslySetInnerHTML={{ __html: _.get(data, "content", t("5c7segpnz0g")) }} />


                            <DatePlaceholder>
                                <img src={shareImage} style={{height: '32px', opacity: 0.5, marginRight: '10px', cursor: 'pointer'}}
                                     onClick={() => {
                                         copy(window.location.href);
                                         toast.success('Ссылка скопирована в буфер обмена');
                                     }}
                                />
                                {(data?.customDate == undefined || data?.customDate == "") ? null :
                                    <span>
                                        {data?.customDate}
                                    </span>
                                        }
                            </DatePlaceholder>


                        </Article.Wrapper>
                    </>
                }
            </Sidebar>

        </Container>
    );
};

export default NewsListPage;

const DatePlaceholder = styled.div`
  font-size: 14px;
  font-style: italic;
  text-align: right;
  opacity: 0.6;
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
`;

const Article = {
    Wrapper: styled(Frame)`
      width: 100%;
      padding: 43px 32px;
      box-sizing: border-box;
      background: white;
      gap: 26px;
      align-items: flex-start;
      border-radius: 12px;
    `,
    Cover: styled(Frame)<{ src: string }>`
      width: 100%;
      height: 365px;
      background: url("${({ src }) => src}") no-repeat center center / cover;
    `,
    Content: styled.div`
      text-align: justify;

      a {
        color: ${({ theme }) => theme.blue};
      }
    `
};